var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDvehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#808080",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.875 11.7207H17.4992C17.1542 11.7207 16.8742 12.0007 16.8742 12.3457C16.8742 12.6907 17.1542 12.9707 17.4992 12.9707H18.875V14.584C18.875 15.2007 18.3833 15.6923 17.7667 15.6923H17.6333C17.6327 15.69 17.632 15.6877 17.6313 15.6854L17.6302 15.6897C17.689 15.8892 17.7206 16.1004 17.7206 16.3189C17.7206 16.5378 17.6889 16.7492 17.63 16.949L17.6311 16.95C17.6318 16.9474 17.6326 16.9449 17.6333 16.9423H17.7667C19.0667 16.9423 20.125 15.884 20.125 14.584V11.7173C20.125 10.684 19.5167 9.75065 18.5833 9.35065L16.125 8.26732V7.81732C16.125 6.51732 15.0667 5.45898 13.7667 5.45898H6.20833C4.925 5.45898 3.875 6.50898 3.875 7.79232V14.584C3.875 15.7067 4.67187 16.6552 5.72712 16.8827C5.68005 16.7027 5.65499 16.5137 5.65499 16.3189C5.65499 15.0917 6.64992 14.0967 7.87725 14.0967C9.10457 14.0967 10.0995 15.0917 10.0995 16.3189C10.0995 16.5366 10.0682 16.7469 10.0099 16.9457H13.3657C13.3073 16.7469 13.276 16.5366 13.276 16.3189C13.276 15.0917 14.271 14.0967 15.4983 14.0967C15.7159 14.0967 15.9263 14.128 16.125 14.1862V9.63398L18.075 10.4923C18.5667 10.7007 18.875 11.184 18.875 11.7173V11.7207Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8746 14.0967C6.64729 14.0967 5.65234 15.0917 5.65234 16.3189C5.65234 17.5463 6.64729 18.5412 7.8746 18.5412C9.10192 18.5412 10.0969 17.5463 10.0969 16.3189C10.0969 15.0917 9.10192 14.0967 7.8746 14.0967ZM6.90234 16.3189C6.90234 15.782 7.33764 15.3467 7.8746 15.3467C8.41157 15.3467 8.84686 15.782 8.84686 16.3189C8.84686 16.8559 8.41157 17.2912 7.8746 17.2912C7.33764 17.2912 6.90234 16.8559 6.90234 16.3189Z",
    fill: "#484848",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4957 14.0967C14.2684 14.0967 13.2734 15.0917 13.2734 16.3189C13.2734 17.5463 14.2684 18.5412 15.4957 18.5412C16.723 18.5412 17.7179 17.5463 17.7179 16.3189C17.7179 15.0917 16.723 14.0967 15.4957 14.0967ZM14.5234 16.3189C14.5234 15.782 14.9588 15.3467 15.4957 15.3467C16.0327 15.3467 16.4679 15.782 16.4679 16.3189C16.4679 16.8559 16.0327 17.2912 15.4957 17.2912C14.9588 17.2912 14.5234 16.8559 14.5234 16.3189Z",
    fill: "#484848",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvehicle);
export default __webpack_public_path__ + "static/media/Dvehicle.3ec950696924e08044b25a7a4eae526e.svg";
export { ForwardRef as ReactComponent };